import { FetchHttpClient } from "src/app/infrastructure/FetchHttpClient";

const httpClient = new FetchHttpClient();

export default httpClient;